import classNames from 'classnames';
import { NotificationProps } from './types';

export default function Notification({ variant, children, className }: NotificationProps) {
  const classes = classNames(
    'flex p-4',
    {
      'bg-green-100 border border-green-400 text-green-800': variant === 'success',
      'bg-red-100 border border-red-400 text-red-800': variant === 'error',
      'bg-gray-100 border border-gray-300 text-gray-700': variant === 'info'
    },
    className
  );

  return <div className={classes}>{children}</div>;
}
